// extracted by mini-css-extract-plugin
module.exports = {"validationMsg":"ValidationMessage-module--validationMsg--b2YJH","text":"ValidationMessage-module--text--3bYvy","icon":"ValidationMessage-module--icon--lhgwJ"};